import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import Screen from './Screen'
import { getThemedBlankViewImage } from 'src/Libs/utils'
import { BlankViewImageVariants } from 'src/Components/blank-view'

interface Props {
  onClose: () => void
}

const LoadingError: React.FC<Props> = ({ onClose }) => {
  const { t } = useCustomTranslation()
  const blankViewImageWorried = getThemedBlankViewImage(BlankViewImageVariants.Worried)
  return (
    <Screen
      title={t('installation-statement.modal-state.loading-error.title')}
      body={t('installation-statement.modal-state.loading-error.body')}
      imageSource={blankViewImageWorried}
      hasFooter={true}
      onClose={onClose}
    />
  )
}

export default LoadingError
